var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"js-snz-widget p-16 tablet:p-0",class:("js-snz-widget--" + (_vm.widgetKey.toLowerCase())),attrs:{"data-hash":_vm.widgetHash}},[_c('div',{staticClass:"snz-spinner"})])])}
var staticRenderFns = []

export { render, staticRenderFns }